var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';

var buttonColor = function buttonColor(p, hover) {
  if (p.invert) {
    switch (p.brand) {
      case 'lowContrast':
        return hover ? p.theme.highContrast : p.theme.lowContrast;

      case 'highContrast':
        return hover ? p.theme.lowContrast : p.theme.highContrast;

      default:
        return hover ? p.theme.white : buttonBackgroundColor(p, 0, true, false);
    }
  } else {
    switch (p.brand) {
      case 'lowContrast':
        return p.theme.highContrast;

      case 'highContrast':
        return p.theme.lowContrast;

      default:
        return p.theme.white;
    }
  }
};

var buttonBackgroundColor = function buttonBackgroundColor(p, colorLevel, gradientStart, allowTransparent) {
  var retVal = '';

  if (p.theme.themeName === 'greenlight' || p.theme.themeName === 'dark' || p.theme.themeName === 'newlight') {
    if (p.brand === 'primary') {
      if (gradientStart) {
        retVal = p.invert && allowTransparent ? 'transparent' : p.theme['primaryA'];
      } else {
        retVal = p.invert && allowTransparent ? 'transparent' : p.theme['primaryB'];
      }
    } else {
      retVal = p.invert && allowTransparent ? 'transparent' : p.theme[p.brand];
    }
  } else {
    retVal = p.invert && allowTransparent ? 'transparent' : p.theme[p.brand];
  }

  if (colorLevel !== 0) {
    retVal = p.theme.colorLevel(retVal, colorLevel);
  }

  return retVal;
};

var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  background: linear-gradient(90deg, ", " 0%, ", " 100%); \n  border: ", " solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  display: inline-block;\n  font-size: ", ";\n  padding: ", ";\n  object-fit: contain;\n  text-align: center;\n  transition: box-shadow 75ms ease-out;\n  vertical-align: middle;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:hover:not(:disabled) {\n    //background-color: ", ";\n    background: linear-gradient(90deg, ", " 0%, ", " 100%); \n\n    border-color: ", ";\n    color: ", ";\n    box-shadow: ", ", ", ";\n    &:focus {\n      box-shadow: ", ",\n        0 0 0 2px ", ",\n        ", ";\n    }\n  }\n\n  &:active:not(:disabled),\n  &:active:focus:not(:disabled) {\n    //background-color: ", ";\n    background: linear-gradient(90deg, ", " 0%, ", " 100%); \n\n    box-shadow: ", ";\n    color: ", ";\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ", ",\n      0 0 0 2px ", ";\n    outline: 0;\n  }\n"], ["\n  background-color: ", ";\n  background: linear-gradient(90deg, ", " 0%, ", " 100%); \n  border: ", " solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  display: inline-block;\n  font-size: ", ";\n  padding: ", ";\n  object-fit: contain;\n  text-align: center;\n  transition: box-shadow 75ms ease-out;\n  vertical-align: middle;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:hover:not(:disabled) {\n    //background-color: ", ";\n    background: linear-gradient(90deg, ", " 0%, ", " 100%); \n\n    border-color: ", ";\n    color: ", ";\n    box-shadow: ", ", ", ";\n    &:focus {\n      box-shadow: ", ",\n        0 0 0 2px ", ",\n        ", ";\n    }\n  }\n\n  &:active:not(:disabled),\n  &:active:focus:not(:disabled) {\n    //background-color: ", ";\n    background: linear-gradient(90deg, ", " 0%, ", " 100%); \n\n    box-shadow: ", ";\n    color: ", ";\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ", ",\n      0 0 0 2px ", ";\n    outline: 0;\n  }\n"])), function (p) {
  return p.invert ? 'transparent' : buttonBackgroundColor(p, 0, true, false);
}, function (p) {
  return buttonBackgroundColor(p, 0, true, true);
}, function (p) {
  return buttonBackgroundColor(p, 0, false, true);
}, function (p) {
  return p.noBorder ? '0px' : p.theme.borderWidth;
}, function (p) {
  return buttonBackgroundColor(p, 0, true, false);
}, function (p) {
  return p.theme.buttonBorderRadious;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return buttonColor(p, false);
}, function (p) {
  return p.size === 'large' ? '1.25rem' : p.size === 'small' ? '.875rem' : '1rem';
}, function (p) {
  return p.size === 'large' ? '.5rem 1rem' : p.size === 'small' ? '.25rem .5rem' : '.375rem .75rem';
}, function (p) {
  return p.theme.colorLevel(p.theme[p.brand], -1);
}, function (p) {
  return buttonBackgroundColor(p, -1, true, false);
}, function (p) {
  return buttonBackgroundColor(p, -1, false, false);
}, function (p) {
  return buttonBackgroundColor(p, -1, true, false);
}, function (p) {
  return buttonColor(p, true);
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return p.theme.boxShadowLarge;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return buttonBackgroundColor(p, -5, true, false);
}, function (p) {
  return p.theme.boxShadowLarge;
}, function (p) {
  return p.theme.colorLevel(p.theme[p.brand], 3);
}, function (p) {
  return buttonBackgroundColor(p, 3, true, false);
}, function (p) {
  return buttonBackgroundColor(p, 3, false, false);
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.invert ? p.theme.white : p.theme.white;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return buttonBackgroundColor(p, -5, true, false);
}); // TODO: button that looks like a link

var Button = function Button(_a) {
  var invert = _a.invert,
      buttonRef = _a.buttonRef,
      children = _a.children,
      className = _a.className,
      size = _a.size,
      brand = _a.brand,
      others = __rest(_a, ["invert", "buttonRef", "children", "className", "size", "brand"]);

  var classes = className ? className + " btn" : 'btn';
  classes = brand ? classes + " btn-" + ((invert ? 'outline-' : '') + brand) : classes;
  classes = size ? classes + " btn-" + size : classes;
  return React.createElement(StyledButton, Object.assign({
    buttonRef: buttonRef,
    type: "button",
    className: classes,
    brand: brand,
    invert: invert,
    size: size
  }, others), children);
};

export default Button;
var templateObject_1;